"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Lottie = _interopRequireDefault(require("../../../elements/lottie/Lottie"));

var _stitches = require("../../../stitches.config");

/**
 * An element used to display an HTML img or Lottie animation depending on the content type.
 */
var ImageOrLottie = function ImageOrLottie(_ref) {
  var contentType = _ref.contentType,
      css = _ref.css,
      title = _ref.title,
      url = _ref.url;
  var Image = (0, _stitches.styled)('img', css);
  return contentType === 'application/json' ? /*#__PURE__*/_react.default.createElement(_Lottie.default, {
    css: css,
    path: url,
    title: title
  }) : /*#__PURE__*/_react.default.createElement(Image, {
    alt: title,
    src: url
  });
};

ImageOrLottie.defaultProps = {
  contentType: '',
  css: {},
  title: '',
  url: ''
};
var _default = ImageOrLottie;
exports.default = _default;